/**
 * type 123
 * @param { Number } 类型
 */
export function getType (val) {
  switch (val) {
    case 1:
      return '校长营'
    case 2:
      return '学科营'
    case 3:
      return '辅导营'
  }
}

/**
 * Period 123
 * @param { Number } 类型
 */
export function getPeriod (val) {
  var arr = String(val).split(',')
  var temp = []
  arr.forEach((item, index) => {
    switch (Number(item)) {
      case 1:
        temp[index] = '第一期'
        break
      case 2:
        temp[index] = '第二期'
        break
      case 3:
        temp[index] = '第三期'
        break
    }
  })
  return temp.join('，')
}

/**
 * 魔法三营 审核状态status 未报名没有val
 * @param { Number } 类型
 */
export function getStatus (val) {
  switch (val) {
    case undefined:
      return '待报名' // 未报名
    case 0:
      return '待审核' // 待审核
    case 1:
      return '审核通过' // 通过
    case 2:
      return '审核未通过' // 不通过
    case 3:
      return '待换人' // 换人
  }
}

/**
 * 新手上路status 未报名没有val
 * @param { Number } 类型
 */

export function getNewStatus (val) {
  switch (val) {
    case 0:
      return '待反馈' // 待反馈
    case 1:
      return '待审核'
    case 2:
      return '审核通过'
    case 3:
      return '审核不通过'
  }
}

/**
 * grade 年级
 * @param { Number } 类型
 */
export function getGrade (val) {
  var arr = String(val).split(',')
  var temp = []
  arr.forEach((item, index) => {
    switch (Number(item)) {
      case 1:
        temp[index] = '一年级'
        break
      case 2:
        temp[index] = '二年级'
        break
      case 3:
        temp[index] = '三年级'
        break
      case 4:
        temp[index] = '四年级'
        break
      case 5:
        temp[index] = '五年级'
        break
      case 6:
        temp[index] = '六年级'
        break
      case 7:
        temp[index] = '七年级'
        break
      case 8:
        temp[index] = '八年级'
        break
      case 9:
        temp[index] = '九年级'
        break
    }
  })
  return temp.join('，')
}

export function getGradeNumber (val) {
  switch (val) {
    case '一年级':
      return 1
    case '二年级':
      return 2
    case '三年级':
      return 3
    case '四年级':
      return 4
    case '五年级':
      return 5
    case '六年级':
      return 6
    case '七年级':
      return 7
    case '八年级':
      return 8
    case '九年级':
      return 9
  }
}

/**
 * version 版本
 * @param { Number } 类型
 */
export function getVersion (val) {
  var arr = String(val).split(',')
  var temp = []
  arr.forEach((item, index) => {
    switch (Number(item)) {
      case 1:
        temp[index] = '全国版'
        break
      case 2:
        temp[index] = '人教版'
        break
      case 3:
        temp[index] = '北师版'
        break
      case 4:
        temp[index] = '浙教版'
        break
    }
  })
  return temp.join('，')
}

/**
 * 获取文件类型
 * @param { Number } 类型
 */
export function getSuffix (val) {
  var temp
  if (/\.(png|jpe?g|gif|svg)(\?.*)?$/.test(val)) {
    temp = '.jpg'
  }
  if (/\.(dotx?|docx?|rtf|txt|pdf)(\?.*)?$/.test(val)) {
    temp = '.word'
  }
  if (/\.(xlsx?|xltx?|htm)(\?.*)?$/.test(val)) {
    temp = '.excel'
  }
  if (/\.(pptx?|potx?)(\?.*)?$/.test(val)) {
    temp = '.ppt'
  }
  if (/\.(flv|rvmb|mp4|avi|wmv)(\?.*)?$/.test(val)) {
    temp = '.video'
  }
  if (/\.(bz2|gz|zip|tar|tar.gz|tar.bz2)(\?.*)?$/.test(val)) {
    temp = '.zip'
  }
  switch (temp) {
    case '.jpg':
      return '/img/jpg.png'
    case '.excel':
      return '/img/excel.png'
    case '.word':
      return '/img/word.png'
    case '.ppt':
      return '/img/ppt.png'
    case '.zip':
      return '/img/zip.png'
    case '.video':
      return '/img/video.png'
    default:
      return '/img/file.png'
  }
}
